import { AlertType } from '../../enums/AlertType';
import { Alert } from '../../interfaces/Alert';

export const ALERT_403: Alert = {
  type: AlertType.Error,
  title: {
    message: 'Error',
    translate: false,
  },
  message: {
    message: 'error.type.login_again',
    translate: true,
  },
};
